export enum USER_TYPE {
  employer = 'employer',
  iraUser = 'iraUser',
  independentIra = 'independentIra',
}
